import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormField, MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { LockerSpirit } from '../../../../../core/models/lockerSpirit.model';
import { Spirit } from '../../../../../core/models/spirit.model';
import { LocalService } from '../../../../../core/services/local.service';

const materialModules = [
  MatIconModule,
  MatButtonModule,
  MatFormFieldModule,
  MatInputModule,
  FormsModule
]

@Component({
  selector: 'app-spirit-detail-locker-add',
  standalone: true,
  imports: [TranslateModule, ...materialModules, MatFormField],
  templateUrl: './spirit-detail-locker-add.component.html',
  styleUrls: ['./spirit-detail-locker-add.component.scss'],
})
export class SpiritDetailLockerAddComponent  implements OnInit {

  local = inject(LocalService);

  @Input() menu: any;
  @Input() spirit: Spirit | null = null;
  @Output() spiritAdded: any = new EventEmitter();

  qty: number = 1;

  constructor() { }

  ngOnInit() {}

  addQty() {
    if (
      !this.menu.user.activeModules.includes('erp') ||
      !this.spirit!.stock ||
      (this.spirit!.stock && !this.spirit!.stock!.stockActive) ||
      (this.spirit!.stock && this.qty < this.spirit!.stock!.stock && this.spirit!.stock!.stockActive)
    ) {
      this.qty++;
    } 
  }

  removeQty() {
    if (this.qty > 1) this.qty--;
  }

  save() {
    const lockerCartString = this.local.getData('lockerCart');
    let lockerCart: any[] = [];
    if (lockerCartString) {
      lockerCart = JSON.parse(lockerCartString);
    }

    const index = lockerCart.findIndex(x => x.spirit.uuid == this.spirit!.uuid);
    if (index == -1) {
      const bottlePrice = this.spirit!.priceVariants.find((x: any) => x.priceVariant.slugName == 'botella');
      lockerCart.push({
        spirit: this.spirit!,
        quantity: this.qty,
        price: bottlePrice?.price ?? 0
      });
    } else {
      lockerCart[index].quantity += this.qty;
    }

    this.local.saveData('lockerCart', JSON.stringify(lockerCart));

    this.spiritAdded.emit();
  }

}
